'use client'

import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'

import { type SellerInsightsType } from '../../constants/insights'
import useGetPhotoRecommendations from '../../hooks/useGetPhotoRecommendations'
import SellerInsightsPhotoRecommendations from './SellerInsightsPhotoRecommendations/SellerInsightsPhotoRecommendations'
import SellerInsightsBlocks from './SellerInsightsBlocks'

type Props = {
  sellerInsights: SellerInsightsType
  isSellerInsightsLoading: boolean
}

const SellerInsights = ({ sellerInsights, isSellerInsightsLoading }: Props) => {
  const { photoRecommendations, isPhotoRecommendationsLoading } = useGetPhotoRecommendations()

  if (isSellerInsightsLoading || isPhotoRecommendationsLoading)
    return <ContentLoader testId="seller-insights-loader" />

  if (!sellerInsights?.isVisible) return null

  return (
    <section>
      <div className="seller-blocks-container">
        {sellerInsights?.isVisible && <SellerInsightsBlocks sellerInsights={sellerInsights} />}
      </div>
      {photoRecommendations && <SellerInsightsPhotoRecommendations {...photoRecommendations} />}
    </section>
  )
}

export default SellerInsights
